<script setup lang="ts">
const route = useRoute()
const nav = computed((): boolean => !!myLinkName(route)?.includes('info-faq'))

const t2 = useT2({})
useHead({
  title: t2('Information'),
})
</script>

<template>
  <AppMenuCont active="info" :nav><NuxtPage /></AppMenuCont>
</template>
